<template>
  <Dialog :show='prompter.active' :okText='prompter.okText' :cancelText='prompter.cancelText' :title='prompter.title'
          @cancel='prompter.resolve(false)' @validate='prompter.resolve(text)'>
    <span class='message'>
      <div class='wrap'>
        <label for='modal-text-value'>{{ prompter.label }}</label>
        <input v-focus v-model='text' :placeholder='prompter.label' name='modal-text-value' required>
      </div>
    </span>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog'
export default {

  name: 'Prompt',

  components: {
    Dialog
  },

  computed: {
    prompter () {
      return this.$store.state.prompt
    },
    text: {
      get () {
        return this.prompter.text
      },
      set (value) {
        this.$store.commit('prompt/UPDATE_TEXT', value)
      }
    }
  }
}
</script>
